import FilterForm from 'components/forms/FilterForm';
import { Empty, Form, FormProps, Input, Select } from 'antd';
import { IGraduateDiscipline } from 'interfaces/graduate_disciplines';
import { SearchOutlined } from '@ant-design/icons';
import { useSelect } from '@refinedev/antd';

export interface IAcademicRecordEquivalenciesFilterForm {
  disciplineId: string;
  by_status: string;
  search_user_name: string;
  by_user_email: string;
  by_agent: string;
}

interface AcademicRecordEquivalenciesFilterProps {
  searchFormProps: FormProps<IAcademicRecordEquivalenciesFilterForm>;
}

export const AcademicRecordEquivalenciesFilter = ({
  searchFormProps
}: AcademicRecordEquivalenciesFilterProps) => {
  const { selectProps: disciplineSelectProps } = useSelect<IGraduateDiscipline>(
    {
      resource: 'graduate_disciplines',
      optionLabel: 'name',
      optionValue: 'id',

      onSearch: value => [
        {
          field: 'filter[name]',
          operator: 'eq',
          value
        }
      ],

      pagination: {
        mode: 'server'
      }
    }
  );

  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="search_user_name">
        <Input
          placeholder="Nome do aluno"
          className="lg:min-w-[300px]"
          suffix={<SearchOutlined />}
        />
      </Form.Item>

      <Form.Item name="by_user_email">
        <Input placeholder="E-mail do aluno" />
      </Form.Item>

      <Form.Item name="disciplineId">
        <Select
          {...disciplineSelectProps}
          placeholder="Disciplina"
          notFoundContent={
            <Empty description="Nenhuma disciplina encontrada. Tente refazer sua busca com outros termos" />
          }
        />
      </Form.Item>

      <Form.Item name="by_status">
        <Select placeholder="Situação" allowClear>
          <Select.Option>Todos</Select.Option>
          <Select.Option key={'approved'}>Aprovado</Select.Option>
          <Select.Option key={'exempted'}>Isento</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
